import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

const LogoutConfirmDialog = ({
  open,
  onClose,
  onConfirm,
  isPending = false,
}) => (
  <Dialog
    open={open}
    onClose={isPending ? undefined : onClose}
    maxWidth="xs"
    fullWidth
  >
    <DialogTitle sx={{ fontWeight: 700, pb: 0.5 }}>Log out?</DialogTitle>
    <DialogContent>
      <Typography variant="body2" color="text.secondary">
        You'll need to log in again to view your orders, cart, and shop.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 2 }}>
      <Button onClick={onClose} disabled={isPending}>
        Cancel
      </Button>
      <Button
        variant="contained"
        onClick={onConfirm}
        disabled={isPending}
        sx={{ bgcolor: "#d32f2f", "&:hover": { bgcolor: "#b71c1c" } }}
      >
        {isPending ? (
          <CircularProgress size={20} sx={{ color: "white" }} />
        ) : (
          "Log out"
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default LogoutConfirmDialog;
